export function formaterPrix(valeur, devise = 'XOF') {
  const n = Number(valeur || 0);
  try {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: devise, maximumFractionDigits: 0 }).format(n);
  } catch {
    return `${n}`;
  }
}
